import { api } from '@forbiz/web-kit'
import type { DigitalWreathSettingResponse, WreathDesignId } from '@forbiz/contracts'

/**
 * 디지털 화환 (BIZ-126 — 목업의 실구현. 옛 이름 '디지털 근조기' — 근조기는 별도 판매 상품으로 분리).
 * 디자인 설정은 서버(company 귀속)에 저장한다. 제휴 장례식장 판정은 장례식장 엔티티
 * (lib/funeralHall.ts resolve → isPartner, BIZ-90)가 맡는다.
 * 디자인 카탈로그(색·이름)는 이 파일이 정본 — 서버는 id만 저장한다(계약 enum과 함께 갱신).
 */

export interface WreathDesign {
  id: WreathDesignId
  name: string
  /** 카드 양옆 바 그라디언트(위→아래). */
  bar: [string, string]
  /** 엠블럼 원 배경 / 국화 색. */
  circleBg: string
  flower: string
}

export const WREATH_DESIGNS: WreathDesign[] = [
  { id: 'gold', name: '클래식 골드', bar: ['#d8bd72', '#c3a04e'], circleBg: '#f0f1f2', flower: '#b9c0c5' },
  { id: 'slate', name: '차분한 슬레이트', bar: ['#8a9aa6', '#5b6c78'], circleBg: '#eef1f3', flower: '#93a1ab' },
  { id: 'pine', name: '소나무', bar: ['#7fa08c', '#4e6f5c'], circleBg: '#eef3f0', flower: '#8fa89a' },
  { id: 'night', name: '밤의 국화', bar: ['#4b5a75', '#2c3850'], circleBg: '#edeff4', flower: '#8d99b0' },
]

export function getWreathDesign(id: string | null | undefined): WreathDesign {
  return WREATH_DESIGNS.find((d) => d.id === id) ?? WREATH_DESIGNS[0]!
}

export const digitalWreathApi = {
  /** 내 디지털 화환 디자인 설정. 아직 안 골랐으면 designId=null. */
  get: () => api.get<DigitalWreathSettingResponse>('/api/my/digital-wreath'),
  update: (designId: WreathDesignId) =>
    api.put<DigitalWreathSettingResponse>('/api/my/digital-wreath', { designId }),
}
